import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="word-counter"
export default class extends Controller {

  COUNTER_ELEMENT_CLASS = 'form-text'

  count() {
    const input_elements = this.element.getElementsByTagName('textarea')
    const counter_elements = this.element.getElementsByClassName(this.COUNTER_ELEMENT_CLASS)

    if (counter_elements.length !== 1 || input_elements.length !== 1) return

    const input_element = input_elements[0]
    const counter_element = counter_elements[0]

    counter_element.textContent = `Word Count: ${this.num_words_for_element(input_element)}`
  }

  num_words_for_element(element) {
    return element.value
      .replace(/[\n|,]/g, ' ')
      .split(' ')
      .filter(element => element).length
  }
}
